<template>

    <div class="d-flex align-items-center justify-content-center mt-4" v-if="pagination.hasMultiplePages">
        <nav aria-label="Pagination résultat de recherche">
            <ul class="pagination">
                <li class="page-item" :class=" pagination.currentPage > 0 ? '' : 'disabled' " :disabled="  pagination.currentPage > 0">
                    <button class="page-link prev" type="button"  @click.prevent="changePage(pagination.currentPage - 1)"><i class="fa-light fa-chevron-left" aria-hidden="true"></i></button>
                </li>

                <li class="page-item" v-for="i in pagination.totalPages" :key="'page' + i" :class="( pagination.currentPage + 1 ) === i ? 'active' : '' ">
                    <button type="button" class="page-link"
                       @click.prevent="changePage(i - 1)">{{ i }}</button>
                </li>

                <li class="page-item" :class=" pagination.currentPage < ( pagination.totalPages - 1) ? '' : 'disabled' " :disabled="pagination.currentPage < ( pagination.totalPages - 1)">
                    <button type="button" class="page-link next"  @click.prevent="changePage(pagination.currentPage + 1)"><i class="fa-light fa-chevron-right" aria-hidden="true"></i></button>
                </li>
            </ul>
        </nav>
        <p class="ms-2">sur {{ pagination.totalPages }}</p>
    </div>

</template>

<script setup>
import { useStore } from 'vuex';
import { computed } from 'vue';

let store      = useStore();
let pagination = computed( () => store.getters.pagination );


function changePage ( page )
{
    store.commit("currentPage", page);
}
</script>

<style scoped>
.page-item.disabled {
    opacity: 0.3;
}

.page-item.active .page-link {
    background: var( --color-primary);
    color: white;
}
</style>
